import { ProfileCardTrigger, ProfilecardTriggerPosition, ProfileClient } from '@atlaskit/profilecard';
import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';

import { getConfig } from '../config';
import { AnalyticsConsumerProps, withAnalytics } from '../hoc/withAnalytics';

const profileClient = new ProfileClient({
  cacheMaxAge: 10e3,
  cacheSize: 20,
  url: `${getConfig().directoryServiceUrl}/graphql`,
});

interface Props {
  children: JSX.Element;
  cloudId: string;
  position?: ProfilecardTriggerPosition;
  siteUrl: string; // without a trailing slash
  userId: string;
}

class WrappedWithProfilecard extends React.PureComponent<Props & InjectedIntlProps & AnalyticsConsumerProps> {
  static defaultProps: {
    position: ProfilecardTriggerPosition;
  } = {
    position: 'left-start',
  };

  render() {
    const profileUrl = `${this.props.siteUrl}/people/${this.props.userId}`;

    return (
      <ProfileCardTrigger
        position={this.props.position}
        cloudId={this.props.cloudId}
        userId={this.props.userId}
        resourceClient={profileClient}
        actions={[
          {
            callback: event => {
              event.preventDefault();
              event.stopPropagation();
              top.location.href = profileUrl;
            },
            label: this.props.intl.formatMessage(messages.view),
          },
        ]}
      >
        {this.props.children}
      </ProfileCardTrigger>
    );
  }
}

export default injectIntl(withAnalytics(WrappedWithProfilecard));

const messages = defineMessages({
  view: {
    defaultMessage: 'View Profile',
    description: 'Link to view the profile for a particular user',
    id: 'uchi.profilecard.viewProfile',
  },
});
